<script>
  import { Line, mixins } from 'vue-chartjs'
  const { reactiveProp } = mixins

  export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ['options'],
    data () {
      return {
      }
    },
    watch: {
      chartData () {
        this.$data._chart.update()
      },
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    },
  }
</script>

<style lang="scss" scoped>
  #line-chart{
    height: 300px !important;
  }
</style>
